document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector('.oito-btn-mobile');
  const nav = document.querySelector('.oito-nav-global');
  const html = document.documentElement;

  if (!button || !nav) return;

  // Calcula a largura da scrollbar do menu mobile
  setTimeout(() => { 
    let l=window.innerWidth-document.documentElement.clientWidth;
    document.documentElement.style.setProperty("--scrollbar-width",l+"px")
  }, 100);

  button.addEventListener('click', function () {
    button.classList.toggle('open');
    nav.classList.toggle('open');
    html.classList.toggle('open');
  });

  // Accordion for Submenus on Mobile
  const subMenuParents = document.querySelectorAll('.oito-nav-item.is-has-sub-menu > a');
  subMenuParents.forEach(item => {
    item.addEventListener('click', (e) => {
      if (window.innerWidth < 900) {
        e.preventDefault();
        const subMenu = item.nextElementSibling;
        if (subMenu && subMenu.classList.contains('sub-menu')) {
          subMenu.classList.toggle('is-active');
          item.classList.toggle('is-opened');
        }
      }
    });
  });
});
